<div class="ts-reactions-bar">
    <!-- Reply — Lovable CommentIcon -->
    <div class="ts-action-wrap ts-action-wrap--reply">
        <button type="button"
                class="ts-action-btn"
                aria-label="Reply"
                (click)="openReplySubmitModal(postData.OriginalPostID, postData.TSID, postData.UserName); $event.stopPropagation()">
            <span class="ts-action-hit ts-action-hit--reply">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="ts-ico-stroke">
                    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                </svg>
            </span>
            <span class="ts-action-count" *ngIf="postData.Reactions?.Replies > 0">{{ postData.Reactions.Replies }}</span>
        </button>
    </div>

    <!-- Repost / Quote — Lovable RepostIcon + existing dropdown behavior -->
    <div class="ts-action-wrap ts-action-wrap--repost">
        <div class="ts-repost-dd">
            <button type="button"
                    class="ts-action-btn"
                    aria-label="Repost"
                    [class.ts-action-btn--on]="postData.Reactions?.repostSelected"
                    (click)="toggleDropdown(); $event.stopPropagation()">
                <span class="ts-action-hit ts-action-hit--repost">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="ts-ico-stroke">
                        <path d="M17 1l4 4-4 4" />
                        <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                        <path d="M7 23l-4-4 4-4" />
                        <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                    </svg>
                </span>
                <span class="ts-action-count" *ngIf="postData.Reactions?.Reposts > 0">{{ postData.Reactions.Reposts }}</span>
            </button>
            <div *ngIf="isDropdownOpen" class="ts-repost-backdrop" (click)="isDropdownOpen = false; $event.stopPropagation()"></div>
            <div *ngIf="isDropdownOpen" class="ts-repost-panel" (click)="$event.stopPropagation()">
                <button type="button" class="ts-repost-row" (click)="saveRePost(postData.TSID, postData.OriginalPostID, '2', postData.Reactions.repostSelected, '1', null); $event.stopPropagation()">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M17 1l4 4-4 4" />
                        <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                        <path d="M7 23l-4-4 4-4" />
                        <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                    </svg>
                    {{ postData.Reactions.repostSelected ? 'Undo Repost' : 'Repost' }}
                </button>
                <button type="button" class="ts-repost-row" (click)="openQuoteModal(postData); $event.stopPropagation()">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                    </svg>
                    Quote
                </button>
            </div>
        </div>
    </div>

    <!-- Love — Lovable HeartIcon -->
    <div class="ts-action-wrap ts-action-wrap--love">
        <button type="button"
                class="ts-action-btn"
                aria-label="Like"
                [class.ts-action-btn--on]="postData.Reactions?.likeSelected"
                (click)="toggleReaction(postData.TSID, '3'); $event.stopPropagation()">
            <span class="ts-action-hit ts-action-hit--love">
                <svg width="18" height="18" viewBox="0 0 24 24" class="ts-ico-heart"
                     [attr.fill]="postData.Reactions?.likeSelected ? 'currentColor' : 'none'"
                     stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                </svg>
            </span>
            <span class="ts-action-count" *ngIf="postData.Reactions?.Likes > 0">{{ postData.Reactions.Likes }}</span>
        </button>
    </div>

    <!-- Score — mini flame (same motif as header score), opens existing score modal -->
    <div class="ts-action-wrap ts-action-wrap--score">
        <button type="button"
                class="ts-action-btn"
                aria-label="Score"
                (click)="openScoreModal(postData); $event.stopPropagation()">
            <span class="ts-action-hit ts-action-hit--score">
                <svg class="ts-flame-mini" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                    <defs>
                        <linearGradient [attr.id]="'tsFlameMini-' + postData.TSID" x1="0%" y1="100%" x2="100%" y2="0%">
                            <stop offset="0%" stop-color="hsl(30, 85%, 50%)" />
                            <stop offset="100%" stop-color="hsl(42, 90%, 55%)" />
                        </linearGradient>
                    </defs>
                    <path [attr.fill]="'url(#tsFlameMini-' + postData.TSID + ')'"
                          stroke="none"
                          d="M12 2.2c-1.2 3.2-3.8 5.4-5.1 8.5-.8 2-.6 4.1.8 5.6 1.5 1.7 3.8 2.5 6.3 2.5s4.8-.8 6.3-2.5c1.4-1.6 1.6-3.6.8-5.6-1.3-3.1-3.9-5.3-5.1-8.5-.2-.5-.8-.5-1 0z" />
                </svg>
            </span>
        </button>
    </div>

    <!-- Bookmark + Share — Lovable PostActionBar extras (UI only; no backend yet) -->
    <div class="ts-action-wrap ts-extra-pair">
        <button type="button"
                class="ts-action-btn"
                aria-label="Bookmark"
                [class.ts-action-btn--on]="bookmarkToggled"
                (click)="toggleBookmarkUi($event)">
            <span class="ts-action-hit ts-action-hit--bookmark">
                <svg width="18" height="18" viewBox="0 0 24 24"
                     [attr.fill]="bookmarkToggled ? 'currentColor' : 'none'"
                     stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
                </svg>
            </span>
        </button>
        <button type="button"
                class="ts-action-btn"
                aria-label="Share"
                (click)="onShareClick($event)">
            <span class="ts-action-hit ts-action-hit--share">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                    <polyline points="16 6 12 2 8 6" />
                    <line x1="12" y1="2" x2="12" y2="15" />
                </svg>
            </span>
        </button>
    </div>
</div>
